import { map } from 'lodash/fp';

import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import type { CustomService } from './types';

const formatDataForContentTile = ({ serviceTiles = [] }: { serviceTiles?: CustomService[] }) =>
  map(
    ({ imageObject, slogan, summary, urlObject }) => ({
      ctas: [{ name: urlObject?.name, url: urlObject?.url?.trim() }],
      image: getImageAttributes({ height: 240, imageObject }),
      subtitle: summary,
      title: slogan,
    }),
    serviceTiles,
  );

export default formatDataForContentTile;
